(function () {
  "use strict";

  var headerSlimHeight = $(".it-header-slim-wrapper").height();
  var isSlim = false;

  window.addEventListener("scroll", (e) => {
    if (!isSlim && window.scrollY >= headerSlimHeight) {
      $("#block-bootstrap-italia-account-menu").prependTo(
        "#header-navbar-wrapper-offcanvas"
      );
      isSlim = true;
    } else if (isSlim && window.scrollY < headerSlimHeight) {
      isSlim = false;
      $("#block-bootstrap-italia-account-menu").appendTo(
        "#it-region-header-slim-action"
      );
    }
  });

  var defaultText;
  function setMenuText() {
    if (!$('body').hasClass('user-anonymous')) {
      if (!defaultText)
        defaultText = $(
          "#block-bootstrap-italia-account-menu > div.nav-item.dropdown > a > span"
        ).text();
      $(
        "#block-bootstrap-italia-account-menu > div.nav-item.dropdown > a > span"
      ).text(defaultText);
      let buttonHeight = $(
        "#block-bootstrap-italia-account-menu > div.nav-item.dropdown > a > span"
      ).height();
      let newText = defaultText;
      if (buttonHeight > 25) {
        $(
          "#block-bootstrap-italia-account-menu > div.nav-item.dropdown > a > span"
        ).text(newText.split(", ")[1]);
      }
    } else {
      if(!defaultText)
      defaultText = $(
        "#block-bootstrap-italia-account-menu > div.nav-item.dropdown > a > span"
      ).text();
      let newText = defaultText;
      if($(window).width() < 992) {
      $(
        "#block-bootstrap-italia-account-menu > div.nav-item.dropdown > a > span"
      ).text(newText.split("/")[0]); //remove /Registrati
      } else {
        $(
          "#block-bootstrap-italia-account-menu > div.nav-item.dropdown > a > span"
        ).text(newText);  // restore default value
      }
    }
  }
  var doResize;
  setTimeout(setMenuText, 500);
  $(window).on("resize", function () {
    clearTimeout(doResize);
    doResize = setTimeout(setMenuText, 20);
  });
})(jQuery, Drupal);
